module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"row\"> <div class=\"col-md-8\"> <h3>Carrier Accounts</h3> <div id=\"carrier_account_list\" class=\"carrier-accounts\"></div> </div> <div class=\"col-md-4 add-carrier\"> <h3>Add Carrier Account</h3> <div id=\"carrier_type_filter\"></div> <div id=\"carrier_type_list\"></div> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/carrier_accounts_page.ejs
// module id = 875
// module chunks = 1